


























import DialogReservation from '@components/dialog-content-variants/dialog-reservation.vue';
import { dialogDynamicService } from '@services/dialog-dynamic-service';
import { debounce } from '@services/utils';
import Vue from 'vue';

export default Vue.extend({
	name: 'Reservation',
	props: {
		fullPrice: {
			type: Object,
			required: true,
		},
		isMobile: {
			type: Boolean,
			default: false,
		},
		showDescription: {
			type: Boolean,
			default: true,
		},
		withFixedButton: {
			type: Boolean,
			default: true,
		},
		isUnavailable: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			scrollDebounceFunction: (e: Event) => {},
			showReservationFixedButton: false,
		};
	},
	destroyed() {
		if (this.withFixedButton)
			window.removeEventListener('scroll', this.scrollDebounceFunction);
	},
	mounted() {
		if (this.withFixedButton) {
			this.scrollDebounceFunction = debounce(this.toggleReservationFixedButton, 50);
			window.addEventListener('scroll', this.scrollDebounceFunction);
		}
	},
	methods: {
		showReservationModal(): void {
			dialogDynamicService.open({
				component: DialogReservation,
				props: { fullPrice: this.fullPrice },
				dialogProps: { full: this.isMobile, closeBtn: true },
			});
		},
		toggleReservationFixedButton(): void {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			this.showReservationFixedButton = scrollTop > 0;
		},
	},
});
